export default "__VITE_ASSET__X$emaWNJ__"